<template src="./faultsPage.html"></template>

<script>
import reportMixin from '../../../../../js/reportMixin'

export default {
    name: 'faults-page',
    props: [
        'observations', 
        'headerInputs', 
        'sessionFields', 
        'headerOptionsAndValues', 
        'reportTitle',
        'pipeFlow'
    ],
    mixins: [reportMixin],
    data() {
        return {
            convertedObservations: [],
            faultObservations: []
        }
    },
    computed: {
        session() {
            return this.$store.state.SessionsModule.Session;
        },
        reportSettings() {
            return this.$store.state.ReportsModule.ReportSettings
        },
        otherReportSettings() {
            return this.$store.state.ReportsModule.ReportSettings.OtherActionSettings
        },
        visibleFaultImages() {
            return this.$store.state.ReportsModule.FaultPictureCodes
                .filter((code) => code.isChecked)
                .map((code) => code.name);        
        },
    },
    watch: {
        otherReportSettings: {
            deep: true,
            handler() {
                this.convertObservationsForDisplay();
            },
        }
    },
    methods: {
        getImageUrl(url) {
            if (window.environmentName === 'local') {
                return url;
            }

            let modifiedUrl = url.replace(/^https?:/, '').replace(/3.15.106.54/, window.baseURL);
            return modifiedUrl;
        },
        getHeaderFieldValue(header) {
            let matchingField = this.sessionFields.find((field) => field.LabelText === header);

            if (matchingField) {
                return matchingField.Value;
            } 

            return '';
        },
        calculateFaultPosition(startingPosition, endingPosition) {
            if (startingPosition && endingPosition) {
                return `Position: ${startingPosition} to ${endingPosition}`;
            }

            if (startingPosition && !endingPosition) {
                return `Position: ${startingPosition}`;
            }

            if (!startingPosition && endingPosition) {
                return `Position: ${endingPosition}`;
            }
        },
        calculateTimeStamp(videoPosition) {
            return app.calculateDisplayTimestamp(videoPosition);
        },
        checkLastObservationRow(index) {
            if (index === this.observations.length - 1) {
                return true;
            }

            return false;
        },
        checkSeverity(value) {
            let severityNumber = Number(value);

            if (isNaN(severityNumber)) {
                return value;
            } else {
                severityNumber = Math.floor(severityNumber);
            }

            let severityTypes = {
                Severe: 5,
                Heavy: 4,
                Average: 3,
                Moderate: 2,
                Light: 1,
                None: 0
            }

            let severity = Object.keys(severityTypes).find(key => severityTypes[key] === severityNumber);

            return severity;
        },
        convertObservationsForDisplay() {
            this.convertedObservations = DMUtils.copy(this.faultObservations);
            
            this.convertedObservations.forEach((observation) => {
                if (this.pipeFlow === 'Upstream' && this.reportSettings.OtherActionSettings.chkReverseDistance) {
                    observation.Distance = this.session.LengthSurveyed - observation.Distance;

                    if (Number.isInteger(observation.Distance) === false) {
                        observation.Distance = observation.Distance.toFixed(1)
                    }
                }
                if (this.pipeFlow === 'Upstream' && this.reportSettings.OtherActionSettings.chkReverseClockPositions) {
                    observation.Fields.forEach((field) => {                                
                        if (field.Name === "AtFrom") {
                            if (field.Value) {
                                let from = parseInt(field.Value);
                                if (!isNaN(from)) {
                                    from = 12 - from;
                                    field.Value = from.toString();
                                }
                            }      
                        }
                        else if (field.Name === "To") {
                            if (field.Value) {
                                let to = parseInt(field.Value);
                                if (!isNaN(to)) {
                                    to = 12 - to;                                              
                                    field.Value = to.toString();
                                }
                            }
                        }
                    });
                }
            });

            if (this.reportSettings.OtherActionSettings.chkSortByTime) {
                this.convertedObservations = this.convertedObservations.sort((a,b) => a.VideoPosition - b.VideoPosition);
            }
            else {
                this.convertedObservations =  this.convertedObservations.sort((a,b) => a.Distance - b.Distance);
            }
        }
    },
    created() {
        this.faultObservations = DMUtils.copy(this.observations);
        this.convertObservationsForDisplay();
    }
}

</script>
